import AxiosInstance from '../config/AxiosInstance';

export interface DeviceHealthListParams {
  page: number;
  limit: number;
  searchDevice: string;
  searchLocation: string;
  searchCompany: string;
  searchDate: string;
}

const getDeviceHealthList = async (params: DeviceHealthListParams) => {
  try {
    const { data } = await AxiosInstance.get('/api/inventory/devices/list-health', {
      params: {
        page: params.page,
        limit: params.limit,
        searchDevice: params.searchDevice,
        searchLocation: params.searchLocation,
        searchCompany: params.searchCompany,
        searchDate: params.searchDate,
      },
    });
    return { data };
  } catch (error) {
    throw error;
  }
};

export { getDeviceHealthList };
